module.exports = __webpack_public_path__ + "img/b78f174.jpg";